import { Fragment } from "react";

import Head from "next/head";

import Header from "../../components/Common/Header";
import Footer from "../../components/Common/Footer";
import B2cPage from "../../components/B2cPage";

export const B2c = ({ headerData, headerUseCasesSubMenuData, b2cPageData, footerData, geoIp }) => {
  return (
    <Fragment>
      <Head>
        <title>QuickSell | B2C</title>
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
      </Head>
      <Header headerData={headerData} headerUseCasesSubMenuData={headerUseCasesSubMenuData} geoIp={geoIp} />
      <div className="quicksell-page">
        <B2cPage b2cPageData={b2cPageData} geoIp={geoIp} />
        <Footer footerData={footerData} geoIp={geoIp} />
      </div>
    </Fragment>
  );
};

export default B2c;
